import { render, staticRenderFns } from "./OnlineExtensionsCount.vue?vue&type=template&id=421ac1f5&scoped=true"
import script from "./OnlineExtensionsCount.vue?vue&type=script&lang=js"
export * from "./OnlineExtensionsCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421ac1f5",
  null
  
)

export default component.exports